import { encryptAes256Ecb } from "@repo/shared-utils/crypto";
import {
  BFSL_INVEST_NOW_SCREEN,
  BFSL_INVEST_NOW_TYPE,
  BFSL_TRADING_MALL_AES_KEY,
  BFSL_TRADING_MALL_BASE_URL,
} from "../constants/bfslTradingMall";

export type InvestNowRedirectParams = {
  isin: string;
  bseSchCode: string;
  mobileNo: string;
};

/**
 * Builds BFSL trading mall Invest Now URL.
 * Encrypts the full payload string:
 * req={isin: ..., bseSchCode: ..., screen: mforderpadScreen, mobileNo: ..., type: new}
 * Final URL: .../tradingmall/?req=<aes-256-ecb-ciphertext>
 */
export const buildInvestNowRedirectUrl = ({
  isin,
  bseSchCode,
  mobileNo,
}: InvestNowRedirectParams): string => {
  const payload = `{"isin":"${isin}","bseSchCode":"${bseSchCode}","screen":"${BFSL_INVEST_NOW_SCREEN}","mobileNo":"${mobileNo}","type":"${BFSL_INVEST_NOW_TYPE}"}`;
  const encryptedReq = encryptAes256Ecb(payload, BFSL_TRADING_MALL_AES_KEY);
  return `${BFSL_TRADING_MALL_BASE_URL}?req=${encryptedReq}`;
};
